<template>
  <section class="main-content-section">
    <!-- <article> -->
    <div class="dver-main-img flex-col-center">
      <content class="flex-col width title-content">
        <title class="title-top">고객에게 맞출게요.</title>
        <title class="title-down">디버 Fit배송</title>
        <button class="main-order-btn" @click="moveOrder()">주문하기</button>
        <div class="flex-row-center order-history" @click="moveHistory()">
          <div class="text-blue">주문내역 바로가기</div>
          <img
            class="right-arrow"
            src="./../../assets/img/main/arrow_right.png"
          />
        </div>
      </content>
    </div>
    <!-- </article> -->
  </section>
</template>
<script>
export default {
  methods: {
    moveOrder() {
      this.$router.push("/orders/form");
    },
    moveHistory() {
      this.$router.push("/my/orders?p=1");
    },
  },
};
</script>
<style src="./mainCommon.css" scoped></style>
<style scoped>
.main-content-section {
  padding: 0;
  margin: 0;
}

.dver-main-img {
  height: 617px;
  width: 100%;
  background: no-repeat url("../../assets/img/main/mobile/main_mobile.png");
  background-size: cover;
}

title {
  display: flex;
  flex-direction: column;
  font-weight: 500;
  margin-bottom: 10px;
}

.title-top {
  color: white;
}

.title-down {
  color: #4e5459;
}

.main-order-btn {
  border-radius: 39px;
  background: #0081ea;
  font-weight: 700;
  margin: 1rem 0 1rem 0;
  width: 130px;
  height: 50px;
  font-size: 18px;
}

.order-history {
  margin-top: 0.5rem;
  cursor: pointer;
}

@media all and (min-width: 1281px) {
  .dver-main-img {
    height: 667px;
    width: 100%;
    background: no-repeat url("../../assets/img/main/desktop/main_desktop.png");
    background-size: cover;
  }

  title {
    font-weight: 500;
    font-size: 50px;
    line-height: 63px;
  }
}

@media all and (min-width: 769px) and (max-width: 1280px) {
  .main-content-section {
    height: 680px;
    width: 100%;
  }
  .dver-main-img {
    /* height: 558px; */
    width: 100%;
    background: no-repeat url("../../assets/img/main/tablet/main_tablet.png");
    background-size: cover;
  }

  .title-content {
    margin: auto 0 97px 48px;
  }

  title {
    font-weight: 500;
    font-size: 36px;
    line-height: 45px;
  }
}

@media all and (max-width: 768px) {
  .dver-main-img {
    height: 617px;
    width: 100%;
    background: no-repeat url("../../assets/img/main/mobile/main_mobile.png");
    background-size: cover;
  }
  .title-top {
    color: #4e5459;
  }

  .title-down {
    color: white;
  }

  .main-order-btn {
    width: 124px;
    height: 50px;
    border-radius: 39px;
    background: #0081ea;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    margin: 1rem 0 1rem 0;
  }

  .order-history {
    margin-top: 1rem;
  }
}
</style>
